import { CONSTANTS } from '@/constants';
import { useGetGroupPermissions, useUser } from '@netfront/gelada-identity-library';
import { isBefore, parse, set } from 'date-fns';
import { useEffect, useState } from 'react';

export const useIsParentCreatedBeforeFirstFeb2026 = () => {
  const { getUser } = useUser();
  const user = getUser();
  const [meetCriteria, setMeetsCriteria] = useState<boolean | undefined>();

  const { handleGetGroupPermissions, isLoading } = useGetGroupPermissions({
    onCompleted: ({ membershipConnection: { edges } }) => {
      if (edges.length === 0) {
        setMeetsCriteria(false);
        return;
      }
      const node = edges[0].node;
      const userType = node.userType?.id ?? CONSTANTS.USER_TYPE.PARENT.ID;
      const isParent = userType === CONSTANTS.USER_TYPE.PARENT.ID;
      try {
        const membershipCreated = parse(node.created, 'M/d/yyyy', new Date());
        setMeetsCriteria(
          isParent &&
            isBefore(
              membershipCreated,
              new Date(2026, 1, 1), // MONTH INDEX, so this is the 1nd of feb
            ),
        );
      } catch (e) {
        setMeetsCriteria(false);
      }
    },
  });

  useEffect(() => {
    if (!user?.id) return;

    handleGetGroupPermissions({
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      userId: user?.id,
    });
  }, [user?.id]);

  return {
    isLoading: isLoading,
    isParentCreatedBeforeFirstFeb2026: meetCriteria,
  };
};
